module.exports = __webpack_public_path__ + "static/media/image_part_009.ff417067.jpg";